export default function Benefits() {
  const benefits = [
    {
      icon: 'ri-shield-check-line',
      title: 'Avoid Costly Penalties',
      description:
        'Protect your firm from fines up to $500,000 and potential professional sanctions for non-compliance.',
    },
    {
      icon: 'ri-lock-line',
      title: 'Protect Client Privilege',
      description:
        'Safeguard attorney-client communications and confidential case information with enterprise-grade security.',
    },
    {
      icon: 'ri-file-shield-line',
      title: 'Reduce Liability Risk',
      description:
        'Minimize exposure to malpractice claims and data breach liability through comprehensive security measures.',
    },
    {
      icon: 'ri-award-line',
      title: 'Enhance Reputation',
      description:
        'Demonstrate commitment to client data protection and professional responsibility standards.',
    },
    {
      icon: 'ri-hand-coin-line',
      title: 'Lower Insurance Costs',
      description:
        'Qualify for reduced cyber insurance premiums with documented compliance and security controls.',
    },
    {
      icon: 'ri-user-heart-line',
      title: 'Build Client Trust',
      description:
        'Strengthen client relationships by showing proactive protection of their sensitive legal matters.',
    },
  ];

  return (
    <section id="benefits" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center mb-4">
            <i className="ri-star-line text-[#e10708] text-xl mr-2 w-5 h-5 flex items-center justify-center"></i>
            <span className="text-[#e10708] text-sm uppercase tracking-widest font-light">
              Why Compliance Matters
            </span>
          </div>

          <h2 className="text-4xl lg:text-5xl font-serif text-[#1A1F2E] leading-tight mb-6">
            Benefits of SB 2610<br />
            Compliance
          </h2>

          <p className="text-gray-600 text-lg max-w-3xl mx-auto leading-relaxed">
            Beyond avoiding penalties, comprehensive cybersecurity compliance provides significant advantages for your law firm's operations, reputation, and client relationships.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-200 group"
            >
              <div className="w-16 h-16 bg-[#e10708]/10 rounded-xl flex items-center justify-center mb-6 group-hover:bg-[#e10708] transition-colors duration-300">
                <i className={`${benefit.icon} text-[#e10708] text-3xl group-hover:text-white transition-colors duration-300 w-8 h-8 flex items-center justify-center`}></i>
              </div>

              <h3 className="text-xl font-bold text-[#1A1F2E] mb-3">
                {benefit.title}
              </h3>

              <p className="text-gray-600 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>

        {/* Stats Section */}
        <div className="mt-16 bg-gradient-to-r from-[#1A1F2E] to-[#2A3142] rounded-2xl p-12">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-[#e10708] text-4xl font-bold mb-2">87%</div>
              <div className="text-white/80 text-sm">
                Fewer Data Breaches
              </div>
            </div>
            <div>
              <div className="text-[#e10708] text-4xl font-bold mb-2">$2.4M</div>
              <div className="text-white/80 text-sm">
                Average Breach Cost Avoided
              </div>
            </div>
            <div>
              <div className="text-[#e10708] text-4xl font-bold mb-2">95%</div>
              <div className="text-white/80 text-sm">
                Client Confidence Increase
              </div>
            </div>
            <div>
              <div className="text-[#e10708] text-4xl font-bold mb-2">30%</div>
              <div className="text-white/80 text-sm">
                Insurance Premium Reduction
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}